import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { MdClear } from "react-icons/md";
import './AsignarHabitaciones.css';
import Select from 'react-select';
import toast, { Toaster } from 'react-hot-toast';
import HabitacionService from '../../services/habitacion.service';
import * as Constants from '../../constants';
import UsuarioService from '../../services/usuario.service';
import { AuthenticationService } from '../../services/authentication.service';
import { FaFilter } from "react-icons/fa6";
import { IoSearch } from "react-icons/io5";


const PopUpAsignarHabitacion = (props) => {

	const [listaHabitaciones, setListaHabitaciones] = useState([])
	const [selectedHabitaciones, setSelectedHabitaciones] = useState([]);
	const [habitacionesAsignadas, setHabitacionesAsignadas] = useState([]);
	const [selectedHabitacionesError, setSelectedHabitacionesError] = useState('');
	const [selectedUsuario, setSelectedUsuario] = useState(null);
	const [idUsuario, setIdUsuario] = useState(null);
	const [filtroNoAsignadas, setFiltroNoAsignadas] = useState(1);
	
	const [activo, setActivo] = useState(1);
	const [listaEstadosHabitacion, setListaEstadosHabitacion] = useState([]);
	const [filtroEdificio, setFiltroEdificio] = useState('');
	const [filtroPlanta, setFiltroPlanta] = useState('');
	const [selectedEstado, setSelectedEstado] = useState('');

	const authenticationService = new AuthenticationService();
	const userRol = authenticationService.getAuthenticationSession().user.idTipo;
	const userEstablecimiento = authenticationService.getAuthenticationSession().user.establecimiento;



	const [t] = useTranslation("global");

	const toastGenericErrorLogin = () => toast.error(t('app.error.login.generic'));

	useEffect(() => {
		obtenerListaHabitacionesByParams(1,null,'','',null);
		obtenerEstadoHabitaciones();
		cargarHabitacionesAsignadas();

		setSelectedUsuario(props.selectedUsuario);

		if (props.selectedUsuario != null) {
			// Modo edicion
			setIdUsuario(props.selectedUsuario.id);
		}

	}, []);

	function handleLogin(e) {
		e.preventDefault()

		// Code to handle login goes here
		props.toggleAsignar()
	}

	const obtenerListaHabitaciones = async () => {
		if (userRol != Constants.ROLE_USUARIO_TRABAJADOR) {
			await HabitacionService.getHabitaciones(props.selectedEstablecimiento.id)
				.then(response => response.json())
				.then(data => setListaHabitaciones(data));
		} else {
			await HabitacionService.getHabitaciones(userEstablecimiento)
				.then(response => response.json())
				.then(data => setListaHabitaciones(data));
		}

	}


	const obtenerEstadoHabitaciones = async () => {
		await HabitacionService.getEstadosHabitacion()
			.then(response => response.json())
			.then(data => setListaEstadosHabitacion(data));

	}

	const obtenerListaHabitacionesByParams = async (activo, selectedEstado, filtroEdificio, filtroPlanta, noAsignadas) => {
		if (userRol != Constants.ROLE_USUARIO_TRABAJADOR) {
			await HabitacionService.getHabitacionesAsignables(props.selectedEstablecimiento.id, selectedEstado, filtroEdificio, filtroPlanta, props.selectedUsuario.id)
				.then(response => response.json())
				.then(data => setListaHabitaciones(data));
		} else {
			await HabitacionService.getHabitacionesAsignables(userEstablecimiento, selectedEstado, filtroEdificio, filtroPlanta, props.selectedUsuario.id)
				.then(response => response.json())
				.then(data => setListaHabitaciones(data));
		}

	}

	const cargarHabitacionesAsignadas = async () => {
		await HabitacionService.getHabitacionesByParams(props.selectedEstablecimiento.id, activo, selectedEstado, filtroEdificio, filtroPlanta, null, null, props.selectedUsuario.id, true,null)
			.then(response => response.json())
			.then(data => setHabitacionesAsignadas(data));
	}


	function validateForm(idUsuario, listaHabitaciones) {

		// Set initial error values to empty  
		setSelectedHabitacionesError('')

		if (listaHabitaciones === null) {
			setSelectedHabitacionesError(t('app.error.campoObligatorio'))
			return;

		}

		if (idUsuario != null) {
			asignarHabitaciones(idUsuario, listaHabitaciones);
			return;
		}

	}


	const crearAsignacion = async () => {
		const asignacion = {
			idUsuario: idUsuario,
			listaHabitaciones: selectedHabitaciones.map(h => h.id)
		};
		validateForm(asignacion);
	}


	const asignarHabitaciones = async (asignacion) => {
		await UsuarioService.asignarHabitaciones(asignacion.idUsuario, asignacion.listaHabitaciones)
			.then((response) => {
				if (response.status === 200) {

					// Close popup on insert success
					props.toggleAsignar();

					// Refresh table
					//					props.limpiarFiltros();
					props.loadUsuariosCamareros();
				} else {
					toastGenericErrorLogin();
				}
			})
			.catch((err) => {
				toastGenericErrorLogin();
			});;
	}


	const optionsNoAsignadas = [
		{ value: 1, label: t('app.label.noAsignadas') },
		{ value: 0, label: t('app.label.todas') }
	];

	const onChangeFiltroNoAsignadas = (ev) => {
		setFiltroNoAsignadas(ev.value);
		obtenerListaHabitacionesByParams(activo, ev.id, filtroEdificio, filtroPlanta, ev.value);
	}

	const onChangeListaHabitaciones = (ev) => {
		setSelectedHabitaciones(ev || [])
		setHabitacionesAsignadas(ev || []);
	}

	const onChangeFiltroEstadoHabitaciones = (ev) => {
		setSelectedEstado(ev.id)
		obtenerListaHabitacionesByParams(activo, ev.id, filtroEdificio, filtroPlanta, filtroNoAsignadas);
	}

	const onChangeFiltroEdificio = (ev) => {
		setFiltroEdificio(ev.target.value)
		obtenerListaHabitacionesByParams(activo, selectedEstado, ev.target.value, filtroPlanta, filtroNoAsignadas);
	}

	const onChangeFiltroPlanta = (ev) => {
		setFiltroPlanta(ev.target.value)
		obtenerListaHabitacionesByParams(activo, selectedEstado, filtroEdificio, ev.target.value, filtroNoAsignadas);
	}
	
	

	const limpiarFiltros = () => {
		setFiltroEdificio('')
		setFiltroPlanta('');
		setSelectedEstado(null);
		obtenerListaHabitacionesByParams(1,null,'','',null);
	}


	const cancelarAsignacion = () => {
		// Close popup
		props.toggleAsignar();
	}
	
	const colorFiltros = {
	  menuList: styles => ({
	    ...styles,
	    background: '#FAE6F1',
	  }),
	  option: (styles, { isFocused, isSelected }) => ({
	    ...styles,
	    background: isSelected
	        ? '#91005F'
	        : '#FAE6F1',
	    zIndex: 1,
	    "&:hover": {
			background: 'rgba(145, 0, 95, 0.2)',
			color: '#000'
		},
	  }),
	  menu: base => ({
	    ...base,
	    zIndex: 100
	  }),
}

// Para mostrar el color de fondo de la opción elegida en la lista de Estado de habitación
	const getOptionValueEstadoHabitacion = option => option.id;


	return (
		<div className="popup">
			<div className="popup-inner">
				<div className="popup-Header">
					<h1 className={"popup-Title"}>{t("app.empleado.asignarHabitacions")}</h1>
					<button className="popup-btn-x" onClick={cancelarAsignacion}><MdClear /></button>
				</div>
				<div className="popup-Content">
					<form onSubmit={handleLogin} >
						<div className="popup-div-inputs-empleadoAsignar">

							<div>
								<div className={'filtrosPopAsignar'}>

									{/*
									<div className={'filterItem'}>
										<label className={'fieldsetLabel'}>{t("app.label.asignadas")}</label>
										<Select
											className={'filtroSelect'}
											defaultValue={optionsNoAsignadas[0]}
											value={optionsNoAsignadas.find(e => e.value === filtroNoAsignadas)}
											options={optionsNoAsignadas}
											onChange={option => onChangeFiltroNoAsignadas(option)}
											isSearchable={false}
										/>
									</div>
									*/}
									<div className={'filterItemPopAsignar'} >
										<Select
											className="filtroSelect"
											placeholder={t("app.poup.label.seleccionarEstadoHabitacion")}
											key={selectedEstado || ''}
											value={listaEstadosHabitacion.find(e => e.id === selectedEstado)}
											onChange={(e) => onChangeFiltroEstadoHabitaciones(e)}
											options={listaEstadosHabitacion}
											isSearchable={false}
											formatOptionLabel={estado => (
												<div>
													<span>{estado.estado}</span>
												</div>
											)}
											styles={colorFiltros}
											getOptionValue={getOptionValueEstadoHabitacion}
										/>
									</div>
									
									<div className={'filterItemPopAsignar'} >

									<div className={'div_img-filtroInputTextAsignar'}>
										<IoSearch className="iconSearch" size="20" />
										<input
											placeholder={t('app.placeholder.buscarEdificio')}
											className={'filtroInputText'}
											type="search"
											value={filtroEdificio}
											onChange={onChangeFiltroEdificio}
										/>
									</div>
									</div>

									<div className={'filterItemPopAsignar'} >
									<div className={'div_img-filtroInputTextAsignar'}>
										<IoSearch className="iconSearch" size="20" />
										<input
											placeholder={t('app.placeholder.buscarPlanta')}
											className={'filtroInputText'}
											type="search"
											value={filtroPlanta}
											onChange={onChangeFiltroPlanta}
										/>
									</div>
									</div>

									<div className={'filterItemPopAsignar'} >
									<div className={'boton-limpiarFiltro'}>
										<button type="button" className={'btn-limpiarFiltro'} onClick={limpiarFiltros}><FaFilter /> <p className="txt-btn-limpiarFiltro"></p>{t("app.cama.limpiarFiltros")}</button>
									</div>
									</div>
								</div>
							</div>


							<div className={'selectContainerMulti'}>
								<Select
									className="selectMulti"
									placeholder={t("app.label.seleccionarHabitaciones")}
									onChange={(e) => onChangeListaHabitaciones(e)}
									value={listaHabitaciones.filter(e => habitacionesAsignadas.some(a => a.id === e.id))}
									options={listaHabitaciones}
									isSearchable={false}
									isMulti
									getOptionLabel={(e) => e.numero}
									getOptionValue={(e) => e.id}
									formatOptionLabel={tipo => (
										<div>
											<span>{tipo.numero}</span>
										</div>
									)}
									styles={colorFiltros}
								/>
								<label className="errorLabel">{selectedHabitacionesError}</label>
							</div>

						</div>
						<div className="popup-div-buttons">
							<button type="button" className="btn-general-colorPink" onClick={cancelarAsignacion}>{t("app.label.cancelar")}</button>
							<button type="button" className="btn-general" onClick={crearAsignacion}>{t("app.label.guardar")}</button>
							<Toaster />
						</div>
					</form>
				</div>
			</div>
		</div>
	)
}

export default PopUpAsignarHabitacion